export default "assets/images/icons/contact-6af3cfc8.svg";